import { Controller } from 'stimulus'
import { useCheckAll } from './mixins/useCheckAll'

export default class extends Controller {
  static targets = ['checkAll', 'checkbox', 'saveButton', 'modal', 'input', 'confirmation']

  static values = {
    type: String,
    persist: Boolean
  }

  connect() {
    useCheckAll(this, this.persistValue, this.typeValue)
    this.toggleSaveButton()
  }

  toggleSaveButton() {
    if (!this.hasSaveButtonTarget) { return }

    const checked = this.checkboxTargets.filter(checkbox => checkbox.checked)
    if (checked.length > 0) {
      this.saveButtonTarget.disabled = false
    } else {
      this.saveButtonTarget.disabled = true
    }
  }

  showModal() {
    this.modalTarget.classList.toggle('hidden')
  }

  copyUrl() {
    const url = this.inputTarget.children[0].value
    navigator.clipboard.writeText(url)
    this.confirmationTarget.classList.remove('hidden')
  }
}
